
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinnigdi() {



    const cardData =
    {
        keyword: 'Cab Service in Nigdi Pradhikaran',
        heading: 'Platinum24 Cabs: Cab Service in Nigdi Pradhikaran',
        headingDescription: ' Platinum24 Cabs provides trusted Cab Service in Nigdi Pradhikaran, offering safe, comfortable, and affordable travel for residents, students, and professionals in this prime PCMC locality. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures reliable rides for local commutes, airport transfers, and outstation journeys. With professional chauffeurs, timely pickups, and transparent pricing, we make travel smooth and stress-free. Whether you need a quick city drop, a family trip, or a corporate transfer, Platinum24 Cabs guarantees 24/7 availability and dependable cab service in Nigdi Pradhikaran.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


            "services": [
    {
      "name": "Nigdi Pradhikaran Cab Service",
      "description": "Our Nigdi Pradhikaran Cab Service provides reliable and comfortable transportation for all your local and outstation travel needs. Whether it's daily commuting, airport transfers, or weekend trips, enjoy prompt pickups, professional drivers, and clean vehicles that ensure a hassle-free journey."
    },
    {
      "name": "Taxi Booking Nigdi Pradhikaran",
      "description": "Book your taxi in Nigdi Pradhikaran effortlessly through our easy-to-use online booking system or phone service. Get instant confirmation, choose from a variety of vehicle options, and enjoy 24x7 availability to suit your travel schedule."
    },
    {
      "name": "Cab Rental Nigdi Pradhikaran",
      "description": "Rent cabs in Nigdi Pradhikaran for short or long durations with flexible rental packages tailored to your needs. Whether for family outings, corporate events, or long-distance travel, our cab rentals come with professional drivers and competitive rates."
    },
    {
      "name": "Nigdi Pradhikaran Local Taxi",
      "description": "For local travel within Nigdi Pradhikaran, our Local Taxi service offers timely, affordable, and safe rides. Perfect for daily commuting, errands, and city exploration, our taxis are available 24x7 with courteous drivers who prioritize your comfort and safety."
    },
    {
      "name": "Affordable Cab Nigdi Pradhikaran",
      "description": "Experience budget-friendly taxi services in Nigdi Pradhikaran without compromising on quality. Our affordable cab options cater to every traveler looking for cost-effective and reliable transportation solutions."
    },
    {
      "name": "Nigdi Pradhikaran Taxi with Driver",
      "description": "Travel stress-free with our Nigdi Pradhikaran Taxi service that includes experienced and professional drivers. Our chauffeurs ensure safe driving, timely arrivals, and excellent customer service for every ride."
    },
    {
      "name": "Nigdi Pradhikaran Airport Taxi",
      "description": "Make your airport transfers smooth and punctual with our Nigdi Pradhikaran Airport Taxi service. Available around the clock, we offer timely pickups and drop-offs to Pune Airport and other nearby airports, helping you avoid last-minute travel stress."
    },
    {
      "name": "Cab Service Near Me Nigdi Pradhikaran",
      "description": "Locate and book trusted cab services near you in Nigdi Pradhikaran quickly and easily. Our extensive network ensures quick dispatch and reliable taxi availability anywhere within the locality."
    },
    {
      "name": "Nigdi Pradhikaran Outstation Taxi",
      "description": "Plan your outstation journeys with our Nigdi Pradhikaran Outstation Taxi service. Enjoy comfortable rides, professional drivers, and flexible packages for weekend trips, business travel, or leisure tours beyond the city limits."
    },
    {
      "name": "Nigdi Pradhikaran Corporate Taxi",
      "description": "Our Corporate Taxi services in Nigdi Pradhikaran are tailored for businesses requiring reliable, timely, and professional transportation solutions for employees, clients, and corporate events. Customized packages and dedicated support ensure seamless corporate travel."
    },
    {
      "name": "Nigdi Pradhikaran Taxi Deals",
      "description": "Avail exciting Nigdi Pradhikaran Taxi Deals featuring special discounts on airport transfers, local rides, and outstation packages. Save more on your travels while enjoying premium service quality."
    },
    {
      "name": "Nigdi Pradhikaran City Taxi",
      "description": "Explore Nigdi Pradhikaran city effortlessly with our City Taxi service. Whether for shopping, sightseeing, or business meetings, our reliable taxis and experienced drivers ensure you get around comfortably and on time."
    },
    {
      "name": "Nigdi Pradhikaran Family Cab",
      "description": "Travel with your family safely and comfortably using our Family Cab service in Nigdi Pradhikaran. Spacious vehicles equipped with safety features and courteous drivers make family trips and daily commutes convenient and stress-free."
    },
    {
      "name": "Taxi Booking Online Nigdi Pradhikaran",
      "description": "Book your Nigdi Pradhikaran taxi online anytime with our secure and user-friendly platform. Manage bookings easily, get instant confirmations, and access 24x7 customer support for all your transportation needs."
    },
    {
      "name": "Nigdi Pradhikaran Taxi Service 24x7",
      "description": "Our 24x7 Taxi Service in Nigdi Pradhikaran ensures you have access to safe and reliable transportation anytime, day or night. Perfect for emergency travel, late-night rides, or early morning airport transfers, our taxis are always ready to serve you."
    }
  ],
  "tableData": [
    ["Nigdi Pradhikaran Cab Service", "Taxi Booking Nigdi Pradhikaran"],
    ["Cab Rental Nigdi Pradhikaran", "Nigdi Pradhikaran Local Taxi"],
    ["Affordable Cab Nigdi Pradhikaran", "Nigdi Pradhikaran Taxi with Driver"],
    ["Nigdi Pradhikaran Airport Taxi", "Cab Service Near Me Nigdi Pradhikaran"],
    ["Nigdi Pradhikaran Outstation Taxi", "Nigdi Pradhikaran Corporate Taxi"],
    ["Nigdi Pradhikaran Taxi Deals", "Nigdi Pradhikaran City Taxi"],
    ["Nigdi Pradhikaran Family Cab", "Taxi Booking Online Nigdi Pradhikaran"],
    ["Nigdi Pradhikaran Taxi Service 24x7", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Trusted Cab Service in Nigdi Pradhikaran",
      "WhyChoosedescription": "Platinum24 Cabs provides reliable and efficient cab services throughout Nigdi Pradhikaran for all your travel needs."
    },
    {
      "WhyChooseheading": "Fast and Convenient Pickup",
      "WhyChoosedescription": "Our drivers are always nearby to ensure quick pickups and timely arrivals in Nigdi Pradhikaran."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel safely in sanitized, air-conditioned cabs maintained for your comfort."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Area Knowledge",
      "WhyChoosedescription": "Our professional drivers are familiar with Nigdi Pradhikaran’s routes to provide smooth and efficient rides."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Enjoy upfront pricing with no hidden charges, including fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our dedicated team is available round the clock to assist with all your booking needs."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
      "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance journeys as per your requirements."
    },
    {
      "WhyChooseheading": "Variety of Vehicle Options Available",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your group size and comfort preferences."
    }
  ]
























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Nigdi Pradhikaran?',
        answer: 'Yes, Platinum24 Cabs provides reliable and convenient cab services in Nigdi Pradhikaran for local travel and outstation trips.',
    },
    {
        question: 'How can I book a cab service in Nigdi Pradhikaran with Platinum24 Cabs?',
        answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for cab service in Nigdi Pradhikaran?',
        answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
    },
    {
        question: 'Can I book cabs for local travel as well as outstation trips from Nigdi Pradhikaran?',
        answer: 'Yes, we provide both local and outstation cab services from Nigdi Pradhikaran to destinations across Maharashtra and beyond.',
    },
    {
        question: 'Are the drivers experienced and knowledgeable about Nigdi Pradhikaran routes?',
        answer: 'Absolutely. Our drivers are professional, licensed, and familiar with Nigdi Pradhikaran and surrounding areas for safe and timely travel.',
    },
    {
        question: 'Can I hire a cab on an hourly basis in Nigdi Pradhikaran?',
        answer: 'Yes, hourly rental packages are available for local travel within Nigdi Pradhikaran and nearby areas.',
    },
    {
        question: 'Are safety and hygiene protocols followed for cab services in Nigdi Pradhikaran?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety measures to ensure passenger protection.',
    },
    {
        question: 'Is cab service in Nigdi Pradhikaran available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab booking and service in Nigdi Pradhikaran for your convenience.',
    },
    {
        question: 'What payment methods are accepted for cab bookings in Nigdi Pradhikaran?',
        answer: 'We accept cash, digital payments, and card payments to make the booking process smooth and flexible.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Nigdi Pradhikaran?',
        answer: 'Yes, you can specify any pickup and drop-off points within Nigdi Pradhikaran as per your requirement.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Amit Shinde',
        feedback: 'The cab service in Nigdi Pradhikaran by Platinum24 Cabs was punctual and comfortable. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Patil',
        feedback: 'Smooth and hassle-free local cab booking experience in Nigdi Pradhikaran. The driver was very professional.',
        rating: 5,
    },
];































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];





const nigdiPradhikaranTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Trusted and affordable cab service in Nigdi Pradhikaran offering local, airport, outstation, corporate, and family taxi services with experienced drivers available 24x7.",
  "areaServed": {
    "@type": "Place",
    "name": "Nigdi Pradhikaran, Pune"
  },
  "serviceType": [
    "Nigdi Pradhikaran Cab Service",
    "Taxi Booking Nigdi Pradhikaran",
    "Cab Rental Nigdi Pradhikaran",
    "Nigdi Pradhikaran Local Taxi",
    "Affordable Cab Nigdi Pradhikaran",
    "Nigdi Pradhikaran Taxi with Driver",
    "Nigdi Pradhikaran Airport Taxi",
    "Cab Service Near Me Nigdi Pradhikaran",
    "Nigdi Pradhikaran Outstation Taxi",
    "Nigdi Pradhikaran Corporate Taxi",
    "Nigdi Pradhikaran Taxi Deals",
    "Nigdi Pradhikaran City Taxi",
    "Nigdi Pradhikaran Family Cab",
    "Taxi Booking Online Nigdi Pradhikaran",
    "Nigdi Pradhikaran Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};









    return (
        <div>

<Helmet>
  <title>Cab Service in Nigdi Pradhikaran | Affordable Taxi Booking Nigdi Pradhikaran</title>
  <meta
    name="description"
    content="Trusted and affordable cab service in Nigdi Pradhikaran offering local, airport, outstation, corporate, and family taxi services with experienced drivers available 24x7."
  />
  <meta
    name="keywords"
    content="Nigdi Pradhikaran Cab Service, Taxi Booking Nigdi Pradhikaran, Cab Rental Nigdi Pradhikaran, Nigdi Pradhikaran Local Taxi, Affordable Cab Nigdi Pradhikaran, Nigdi Pradhikaran Taxi with Driver, Nigdi Pradhikaran Airport Taxi, Cab Service Near Me Nigdi Pradhikaran, Nigdi Pradhikaran Outstation Taxi, Nigdi Pradhikaran Corporate Taxi, Nigdi Pradhikaran Taxi Deals, Nigdi Pradhikaran City Taxi, Nigdi Pradhikaran Family Cab, Taxi Booking Online Nigdi Pradhikaran, Nigdi Pradhikaran Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(nigdiPradhikaranTaxiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/96.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinnigdi;